import { Component } from '@angular/core';

@Component({
  selector: 'app-header-no-tabs',
  templateUrl: './header-no-tabs.component.html',
})
export class HeaderNoTabsComponent {
}
